export const REFERRAL = {
  CAMPAIGN_PARAM: 'campaign',
  PROMOTER_ID_PARAMETER: 'promoter_id',
  DEFAULT_CAMPAIGN_REFERRALS: 'referidos',
  SESSION_KEYS: {
    CAMPAIGN: 'referral_campaign',
    PROMOTER_ID: 'referral_promoter_id',
  },
} as const;
